export const EMAIL = "Astralld133@gmail.com";
export const CV_URL = "/Eldiiar_Dzhumagaziev_CV.pdf";

export const HERO = {
  lines: ["Designing", "identities,", "ideas &", "experiences."],
  intro:
    "I'm Eldiiar, a multidisciplinary designer working across brand identity, art direction, motion and visual storytelling.",
  meta: [
    "Based in Hertfordshire, UK",
    "Golden Ducky Winner 2026",
    "Former Design Intern at Turner Duckworth",
  ],
};

export const MARQUEE = [
  "Brand Identity",
  "Art Direction",
  "Packaging",
  "Typography",
  "Motion Design",
  "Creative Technology",
  "Visual Storytelling",
];

export const ABOUT = {
  headline: ["A designer driven", "by ideas, identity", "and experimentation."],
  copy: [
    "I'm Eldiiar Dzhumagaziev, a third-year Graphic Design, Advertising and Branding student at the University of Hertfordshire. My practice spans branding, visual identity, typography, packaging, motion design and creative technology.",
    "In 2026, I won the Golden Ducky competition while in my second year, competing against final-year students from multiple universities. The award led to a one-month design internship at Turner Duckworth in London, completed in July 2026.",
  ],
  experience: [
    {
      id: "turner-duckworth",
      role: "Design Intern",
      org: "Turner Duckworth",
      place: "London",
      date: "July 2026",
      kind: "Internship",
      text: "Worked on branding and visual identity explorations involving Aldi, Aldi Nord, Pit Boss Grills, Morrisons, Yorkshire Tea, Hershey's and Blue Diamond. Developed logo concepts, research and moodboards in collaboration with art directors.",
    },
    {
      id: "akon-neyo",
      role: "Concert Videographer & Video Editor",
      org: "Akon & Ne-Yo Concert",
      place: "Bishkek, Kyrgyzstan",
      date: "2026",
      kind: "Live event",
      text: "Paid live-event production: filmed performances and edited footage for the concert's social media page.",
    },
  ],
  skills: {
    Software: [
      "Adobe Creative Cloud",
      "Adobe Illustrator",
      "Photoshop",
      "InDesign",
      "After Effects",
      "Premiere Pro",
      "Figma",
      "TouchDesigner",
    ],
    Disciplines: [
      "Brand Identity",
      "Typography",
      "Art Direction",
      "Packaging",
      "Motion Graphics",
      "Video Editing",
    ],
  },
  education: {
    school: "University of Hertfordshire",
    course: "Graphic Design, Advertising and Branding",
    year: "Year 3",
  },
};

export const CONTACT = {
  headline: ["Let's make", "something worth", "remembering."],
  location: "Hertfordshire, United Kingdom",
};
